import React from 'react';
import WrappedBase from './WrappedBase';

import SubscriptionCommitButton from '../containers/SubscriptionCommitButton';

export default class SubscriptionCommitButtonWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <SubscriptionCommitButton {...this.props} />
      </WrappedBase>
    );
  }
}
